import {useEffect} from 'react';

export function useAccountDeletionRefresh(authenticated: boolean, refreshAuth: () => unknown, refreshDeletion: () => unknown) {
    useEffect(() => {
        if (!authenticated) return;
        const refresh = () => {
            if (document.visibilityState === 'hidden') return;
            void refreshAuth();
            void refreshDeletion();
        };
        window.addEventListener('focus', refresh);
        document.addEventListener('visibilitychange', refresh);
        window.addEventListener('bakery:account-read-only', refresh);
        return () => {
            window.removeEventListener('focus', refresh);
            document.removeEventListener('visibilitychange', refresh);
            window.removeEventListener('bakery:account-read-only', refresh);
        };
    }, [authenticated, refreshAuth, refreshDeletion]);
}
